/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Col, Card } from 'reactstrap';
import PropTypes from 'prop-types';
import NewReturnChart from './NewReturnChart';

const NewReturnCustomer = ({ dir, data, viewReportButton, title }) => (
    <Col xs="12">
        <Card className="pb-3 show-categ-daily-sales">
            <div className="card__title row " style={{ position: 'relative' }}>
                {title}
                <div id='dvChartView'>
                {viewReportButton?.()}</div>
            </div>

            {data?.length ? (
                <NewReturnChart
                    dataToPlot={data}
                    height={400}
                    showTitle={false}
                    dir={dir}
                />

            ) : 'No data to display'}
        </Card>
    </Col>

)

NewReturnCustomer.propTypes = {
    dir: PropTypes.string.isRequired,
    data: PropTypes.arrayOf({}).isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
};

NewReturnCustomer.defaultProps = {
    title: 'New/ Return Customer',
}

export default NewReturnCustomer;
